/* yl-product-video.js — plays the product video inside the main gallery (2026-11-02).
   The video tile is a .yl-product__thumb without an image source, so yololife-product-gallery.js already
   moves `is-active` onto it from thumbnail clicks, arrows, swipes and the keyboard, and keeps the hero image.
   Watching that class is the single switch: active → show the player over the hero and play; inactive →
   pause and hide. The "▶ Video" button on the main image simply selects the video tile. */
(function () {
  'use strict';

  function bind(media) {
    var tile = media.querySelector('[data-video-thumb]');
    var stage = media.querySelector('[data-product-video-stage]');
    var video = stage && stage.querySelector('video');
    if (!tile || !stage || !video || media.dataset.videoBound === 'true') return;
    media.dataset.videoBound = 'true';

    var cta = media.querySelector('[data-product-video-play]');

    function hideZoom() {
      media.querySelectorAll('[data-product-zoom-focus], [data-product-zoom-preview]').forEach(function (node) {
        node.classList.remove('is-active');
      });
    }

    function sync() {
      var active = tile.classList.contains('is-active');
      if (active === !stage.hidden) return;
      stage.hidden = !active;
      media.classList.toggle('is-video-active', active);
      if (active) {
        hideZoom();
        // A click on the tile or the button is a user gesture, so playback with sound is allowed;
        // if the browser still refuses, the native controls stay available.
        var playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(function () {});
      } else {
        video.pause();
      }
    }

    new MutationObserver(sync).observe(tile, { attributes: true, attributeFilter: ['class'] });

    // Start playback inside the click itself as well: some mobile browsers only allow play() while the
    // tap is still on the call stack (the observer runs a moment later). The gallery's own click handler
    // was bound first, so the tile is already active here.
    tile.addEventListener('click', sync);

    if (cta) {
      cta.addEventListener('click', function () {
        tile.click();
      });
    }
  }

  function init() {
    document.querySelectorAll('.yl-product__media--has-video').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
